import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Icon} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class SaveIcon extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const {detail, order, index} = this.props;
    const repeatedIndex = detail.findIndex((element, currentIndex) =>
      element.partCode === order.partCode && currentIndex !== index);

    if (repeatedIndex !== -1) {
      this.props.addMessageBoxError(`El repuesto ${order.partCode} se repite en la línea ${repeatedIndex + 1}`);
      return;
    }

    if (!order.partCode || !order.partQuantity || !order.description) {
      this.props.addMessageBoxError('Por favor verifique que los valores de la línea.');
      return;
    }

    if (order.isNew) {
      this.props.addProviderOrderDetail(order.orderCode, order, index);
      return;
    }

    this.props.editProviderOrderDetail(order.orderCode, {
      'newPartCode': order.partCode,
      'oldPartCode': order.oldPartCode,
      'partQuantity': order.partQuantity,
    }, index);
  }

  render() {
    return (
      <Icon link size='large' color='blue' name='save' onClick={this.handleClick} />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'detail': state.providersOrdersManagementDetail.list,
  };
};

const {
  addMessageBoxError,
  addProviderOrderDetail,
  editProviderOrderDetail,
} = Actions;

export default connect(mapStateToProps, {
  addMessageBoxError,
  addProviderOrderDetail,
  editProviderOrderDetail,
})(SaveIcon);
